import type React from "react";
import { useState } from "react";

// @ts-nocheck
import * as styles from "./styles";

import { usePermissions } from "@cobliteam/hooks";

import {
  CaptionBold,
  CaptionDefault,
  ChevronIcon,
  Dropdown,
} from "@cobliteam/base-components";

import {
  EndIcon,
  GeofenceEventInIcon,
  GeofenceEventOutIcon,
  PathTaken,
  PhotoCamIcon,
  PlannedRoute,
  PluggedIcon,
  SpeedEventIcon,
  StartIcon,
  StopInNotRegisteredPlaceIcon,
  StopInRegisteredPlaceIcon,
  StopWithIdleOnIcon,
  UnpluggedIcon,
  VideoCamIcon,
} from "./icons";

import TrackingPermissions from "../../../../../permissions";

interface LegendItem {
  Icon: React.FC<React.SVGProps<SVGSVGElement>>;
  description: string;
}

interface MapLegendProps {
  showMediaEvents: boolean;
}

export const MapLegend: React.FC<MapLegendProps> = ({ showMediaEvents }) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const { isAccessAllowed } = usePermissions();
  const isAllowedToViewPlacesOfInterest = isAccessAllowed(
    TrackingPermissions.VIEW_PLACES_OF_INTEREST,
  );

  const renderLegendItem = (item: LegendItem, idx: number) => {
    const { Icon, description } = item;

    return (
      <div key={idx} className={styles.legendRow}>
        <Icon />
        <CaptionDefault>{description}</CaptionDefault>
      </div>
    );
  };

  const renderOverlay = () => {
    let legendItems: LegendItem[] = [
      { Icon: StartIcon, description: "Início do trajeto" },
      { Icon: EndIcon, description: "Fim do trajeto" },

      {
        Icon: StopWithIdleOnIcon,
        description: "Parada com motor ocioso",
      },
      { Icon: SpeedEventIcon, description: "Velocidade excedida" },
      { Icon: UnpluggedIcon, description: "Dispositivo desconectado" },
      { Icon: PluggedIcon, description: "Dispositivo conectado" },
      { Icon: PlannedRoute, description: "Rota planejada" },
      { Icon: PathTaken, description: "Trajeto feito" },
      {
        Icon: GeofenceEventInIcon,
        description: "Entrada em um local de interesse",
      },
      {
        Icon: GeofenceEventOutIcon,
        description: "Saída de um local de interesse",
      },
    ];
    if (isAllowedToViewPlacesOfInterest) {
      legendItems = [
        ...legendItems,
        {
          Icon: StopInRegisteredPlaceIcon,
          description: "Parada em local cadastrado",
        },
        {
          Icon: StopInNotRegisteredPlaceIcon,
          description: "Parada fora de local cadastrado",
        },
      ];
    } else {
      legendItems = [
        ...legendItems,
        { Icon: StopInNotRegisteredPlaceIcon, description: "Parada" },
      ];
    }
    if (showMediaEvents) {
      legendItems = [
        ...legendItems,
        { Icon: VideoCamIcon, description: "Evento com vídeo" },
        { Icon: PhotoCamIcon, description: "Evento com foto" },
      ];
    }

    return (
      <div className={styles.overlayContainer}>
        {legendItems.map(renderLegendItem)}
      </div>
    );
  };

  const toggleDropdown = () => setIsDropdownOpen(!isDropdownOpen);

  return (
    <div className={styles.wrapper}>
      <Dropdown
        overlay={renderOverlay}
        onClick={toggleDropdown}
        onClose={toggleDropdown}
      >
        <div className={styles.dropdownContainer}>
          <CaptionBold className={styles.dropdownText}>Legenda</CaptionBold>
          <ChevronIcon className={styles.dropdownIcon(isDropdownOpen)} />
        </div>
      </Dropdown>
    </div>
  );
};

export default MapLegend;
